import React from "react"
import { Controller } from "react-hook-form"
// components
import { Button } from "@components/Button"
import { InputWithLabel } from "@components/Form"
import { useSelector } from "react-redux"
// assets

const MedicalInfo = ({ watch, control, errors, setShowClickedButton }) => {
  const { isAddNewPatientLoading } = useSelector((state) => {
    return state.patient
  })
  const password = watch("password")
  const repeatPassword = watch("repeatPassword")

  const currentFormField = [
    "eye",
    "firstName",
    "lastName",
    "password",
    "repeatPassword",
    "country",
    "province",
    "pincode",
    "address",
    "email",
    "contact",
  ]

  const currentFormErrors = Object.keys(errors).filter((key) =>
    currentFormField.includes(key)
  )

  const isButtonDisabled =
    password !== repeatPassword || Object.keys(currentFormErrors)?.length > 0

  return (
    <>
      <div className="w-full md:max-w-[21.87rem] gap-4 flex flex-col">
        <div className="gap-4 flex flex-col bg-[--pure-white] p-4 md:p-0 rounded-2xl border border-[--border-theme-300] md:border-0">
          <h2 className="text-xs font-medium text-[--text-light-gray]">
            MEDICAL INFO
          </h2>
          <InputWithLabel
            label="Eye"
            name="eye"
            rules={{
              required: "eye is required",
            }}
            type="text"
            control={control}
            errors={errors}
            customInput={
              <div className="relative flex items-center rounded-md">
                <Controller
                  control={control}
                  name="eye"
                  rules={{
                    required: "eye is required",
                  }}
                  render={({ field: { onChange, ref } }) => (
                    <div className="flex items-center w-full border border-[var(--border-secondary)] rounded-lg">
                      <div className="flex items-center w-1/3 gap-2 py-2.5 px-6 border-r">
                        <input
                          type="radio"
                          id="left"
                          name="eye"
                          value="left"
                          onChange={onChange}
                          ref={ref}
                          className="h-4 w-4"
                        />
                        <label
                          className="text-sm font-bold text-[#344054]"
                          htmlFor="left"
                        >
                          left
                        </label>
                      </div>

                      <div className="flex items-center w-1/3 gap-2 py-2.5 px-6 border-r">
                        <input
                          type="radio"
                          id="right"
                          name="eye"
                          value="right"
                          onChange={onChange}
                          ref={ref}
                          className="h-4 w-4"
                        />
                        <label
                          className="text-sm font-bold text-[#344054]"
                          htmlFor="right"
                        >
                          right
                        </label>
                      </div>
                      <div className="flex items-center w-1/3 gap-2 py-2.5 px-6">
                        <input
                          type="radio"
                          id="both"
                          name="eye"
                          value="both"
                          onChange={onChange}
                          ref={ref}
                          className="h-4 w-4"
                        />
                        <label
                          className="text-sm font-bold text-[#344054]"
                          htmlFor="both"
                        >
                          both
                        </label>
                      </div>
                    </div>
                  )}
                />
              </div>
            }
            isRequired
          />
        </div>
        <div className="gap-4 flex flex-col bg-[--pure-white] p-4 md:p-0 rounded-2xl border border-[--border-theme-300] md:border-0">
          <Button
            variant="primary"
            type="submit"
            size="md"
            disabled={isButtonDisabled}
            onClick={() => {
              setShowClickedButton("save")
            }}
            className="font-medium"
            loading={isAddNewPatientLoading}
          >
            Save
          </Button>

          <div className="flex flex-col gap-2 items-center">
            <Button
              variant="transparent"
              className="text-[--primary-blue] border border-[--border-secondary] !font-bold w-full"
              type="submit"
              size="md"
              disabled={isButtonDisabled}
              onClick={() => {
                setShowClickedButton("save and proceed to plan")
              }}
              loading={isAddNewPatientLoading}
            >
              Save and Proceed to plan
            </Button>
            <div className="text-xs text-[--text-light-gray]">
              You can select the plan later from patient detail
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default MedicalInfo
